// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__7Zdc5","rotating":"Loading_rotating__oaE4b","loader":"Loading_loader__rS1ky","wrapper":"Loading_wrapper__dX-L7"};